module.exports = __webpack_public_path__ + "static/img/8.647ef54.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/zh/8.png
// module id = e1Q3
// module chunks = 0